import { EntityTypesSupportedByMapsPage } from "@mapmycustomers/shared/types/entity";
import { MapFilterModel } from "@mapmycustomers/shared/types/viewModel/internalModel/MapFilterModel";

import { MAP_ENTITY_TYPES } from "@app/util/map/consts";

// an entity key with no conditions filters nothing, so it does not count as used
const getUsedEntityTypes = (filter: MapFilterModel): EntityTypesSupportedByMapsPage[] =>
  MAP_ENTITY_TYPES.filter((entityType) => !!filter[entityType]?.conditions.length);

export default getUsedEntityTypes;
